import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IPotentialSavingsDTO } from '@modules/potential-save-modal/dto/i-potential-savings.dto';

@Component({
	selector: 'app-coverage-plan',
	templateUrl: './coverage-plan.component.html',
	styleUrls: ['./coverage-plan.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoveragePlanComponent {
	@Input() public data?: Pick<IPotentialSavingsDTO, 'coverage'>;
	@Input() public isZestyDomain: boolean;
	@Input() public form: FormGroup;

	@Output() public applyChanges: EventEmitter<void> = new EventEmitter<void>();

	public getFormControl(path: string): FormControl {
		return this.form?.get(path) as FormControl;
	}
}
